import { formatDisplayDate } from "../../../../../utils/voucherHelpers";
import { getTimeAgo } from "../../../../../utils/formatters";
import { getAssetUrl } from "../../../../../utils/assetUtils";

export { getTimeAgo, getAssetUrl };

export const getCleanTerminalDisplay = (term, mode) => {
  if (!term) return null;
  const str = String(term).trim();
  if (!str) return null;
  if (/airport|national|international|aerodrome/i.test(str)) {
    const match = str.match(/\b(?:terminal|t)[-\s]*([0-9]+[a-z]?)\b/i) || str.match(/\bT([0-9]+)\b/i);
    if (!match) return null;
    return mode === 'train' ? `PF ${match[1].toUpperCase()}` : `Terminal ${match[1].toUpperCase()}`;
  }
  const matchNum = str.match(/^(?:terminal|t|pf|platform)?[-\s]*([0-9]+[a-z]?)$/i);
  if (matchNum) {
    return mode === 'train' ? `PF ${matchNum[1].toUpperCase()}` : `Terminal ${matchNum[1].toUpperCase()}`;
  }
  const digitMatch = str.match(/\b([0-9]+[a-z]?)\b/i);
  if (digitMatch && str.length <= 6) {
    return mode === 'train' ? `PF ${digitMatch[1].toUpperCase()}` : `Terminal ${digitMatch[1].toUpperCase()}`;
  }
  return null;
};

export const getInviteMessage = (voucher) => {
  if (!voucher) return "";
  const guestName = voucher.guest_information?.guest_name || 'Guest';
  const bookingId = voucher.booking_id || "";

  return `Hello ${guestName},
Here are your trip details!

*Login Credentials:*
*Your Name:* Enter your name
*Booking ID:* ${bookingId}

📲 *Download App to view Voucher:*
*Android:* https://play.google.com/store/apps/details?id=live.trrip.app&hl=en_IN&bookingId=${bookingId}
*iOS:* https://apps.apple.com/in/app/trrip-your-ontour-assistant/id6759519854

Have a wonderful trip!`;
};

export const getDestinationsList = (voucher) => {
  if (voucher?.tour_info?.destinations?.length > 0) {
    return voucher.tour_info.destinations.map(d => d.city || d.location_name).filter(Boolean);
  }
  return ["Phuket", "Thailand"];
};

export const getTripDates = (voucher) => {
  const start = voucher?.tour_info?.start_date ? formatDisplayDate(voucher.tour_info.start_date) : "";
  const end = voucher?.tour_info?.end_date ? formatDisplayDate(voucher.tour_info.end_date) : "";
  if (start && end) return `${start} - ${end}`;
  if (start) return start;

  if (voucher?.itinerary && voucher.itinerary.length > 0) {
    const itinStart = formatDisplayDate(voucher.itinerary[0].date) || "";
    const itinEnd = formatDisplayDate(voucher.itinerary[voucher.itinerary.length - 1].date) || "";
    if (itinStart && itinEnd) return `${itinStart} - ${itinEnd}`;
    if (itinStart) return itinStart;
  }
  return "N/A";
};

export const getPartnerVisibilityText = (voucher) => {
  if (!voucher) return "Visible (All)";
  if (voucher.hide_partners) return "Hidden (All)";
  const visible = [];
  if (voucher.partner_visibility?.restaurant !== false) visible.push("Food");
  if (voucher.partner_visibility?.activity !== false) visible.push("Activities");
  if (voucher.partner_visibility?.shop !== false) visible.push("Shopping");

  if (visible.length === 3) return "Visible (All)";
  if (visible.length === 0) return "Hidden (All)";
  return `Visible: ${visible.join(', ')}`;
};

export const getItineraryBadgeText = (voucher) => {
  if (!voucher?.itinerary || voucher.itinerary.length === 0) return "N/A";
  const now = new Date();
  const todayStr = now.toDateString();

  const isToday = voucher.itinerary.some(itin => {
    if (!itin.date) return false;
    return new Date(itin.date).toDateString() === todayStr;
  });
  if (isToday) return "TODAY";

  const firstDayStr = voucher.itinerary[0].date;
  if (firstDayStr) {
    const firstDate = new Date(firstDayStr);
    firstDate.setHours(0, 0, 0, 0);
    const nowDate = new Date();
    nowDate.setHours(0, 0, 0, 0);

    if (nowDate < firstDate) return "DAY 1";

    const lastDayStr = voucher.itinerary[voucher.itinerary.length - 1].date;
    if (lastDayStr) {
      const lastDate = new Date(lastDayStr);
      lastDate.setHours(0, 0, 0, 0);
      if (nowDate > lastDate) return "COMPLETED";
    }
  }

  return "DAY 1";
};
